import Vue from 'vue'
import axios from '../../axios-auth'

const state = {
  addresses: [],
  currentAddress: {}
}

const getters = {
  addresses: state => state.addresses,
  currentAddress: state => state.currentAddress
}

const actions = {
  deleteAddressById ({commit, getters, dispatch}, id) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.delete(`/addresses/${id}`, {
        headers: {
          Authorization: authValue
        }
      }).then(() => {
        commit('setCurrentAddress', {})
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => {
        reject(err)
      })
    })
  },
  fetchAddressById ({commit, getters, dispatch}, id) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.get(`/addresses/${id}`, {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        commit('setCurrentAddress', response.data)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => {
        reject(err)
      })
    })
  },
  fetchAddresses ({commit, getters, dispatch}) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.get('/addresses', {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        commit('setAddresses', response.data)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => {
        reject(err)
      })
    })
  },
  storeAddress ({commit, getters, dispatch}, address) {
    const currentUser = getters.currentUser
    address.user = {
      id: currentUser.id
    }
    const idToken = currentUser.idToken
    const authValue = 'Bearer '.concat(idToken)
    return new Promise((resolve, reject) => {
      axios.post('/addresses', address, {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        commit('addAddress', {
          ...address,
          id: response.data.id,
          numberOfContracts: 0
        })
        commit('setCurrentAddress', {})
        dispatch('setLogoutTimer')
        resolve()
      }).catch((response) => {
        reject(response)
      })
    })
  },
  updateAddress ({getters, commit, dispatch}, data) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      const address = {
        ...data,
        user: {
          id: currentUser.id
        }
      }
      axios.put(`/addresses/${address.id}`, address, {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        commit('updateAddress', data)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => {
        reject(err)
      })
    })
  }
}

const mutations = {
  addAddress (state, address) {
    state.addresses.push(address)
  },
  setAddresses (state, addresses) {
    state.addresses = addresses
  },
  setCurrentAddress (state, address) {
    state.currentAddress = address
  },
  updateAddress (state, address) {
    const addressToUpdateIndex = state.addresses.findIndex(addressToUpdate => addressToUpdate.id === address.id)
    Vue.set(state.addresses, addressToUpdateIndex, address)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/addresses.js